import axiosInstance from "../utils/axios";

export const migranCenterService = {
  fetchAll: async (params = {}) => {
    const response = await axiosInstance.get("/migran-center", { params });
    return response.data;
  },

  fetchEligibleInstitutions: async (params = {}) => {
    const response = await axiosInstance.get("/migran-center/eligible-institutions", {
      params,
    });
    return response.data;
  },

  findById: async (id) => {
    const response = await axiosInstance.get(`/migran-center/${id}`);
    return response.data;
  },

  store: async (data) => {
    const response = await axiosInstance.post("/migran-center", data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await axiosInstance.put(`/migran-center/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await axiosInstance.delete(`/migran-center/${id}`);
    return response.data;
  },

  exportExcel: async (params = {}) => {
    const response = await axiosInstance.get("/migran-center/export-excel", {
      params,
      responseType: "blob",
    });
    return response;
  },
};

export default migranCenterService;
